import { render, staticRenderFns } from "./LvQuesListSortByRisk.vue?vue&type=template&id=3508aa98"
import script from "./LvQuesListSortByRisk.vue?vue&type=script&lang=js"
export * from "./LvQuesListSortByRisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports